import { render, staticRenderFns } from "./PaginaDeApresentacao.vue?vue&type=template&id=126d6542&scoped=true"
var script = {}
import style0 from "./PaginaDeApresentacao.vue?vue&type=style&index=0&id=126d6542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126d6542",
  null
  
)

export default component.exports